import { render, staticRenderFns } from "./back-to-sourcing.vue?vue&type=template&id=725a06e7&"
import script from "./back-to-sourcing.vue?vue&type=script&lang=js&"
export * from "./back-to-sourcing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports